<script>
import simplebar from "simplebar-vue";
import Layout from "../../layouts/main.vue";
import PageHeader from "../../components/page-header.vue";
import moment from 'moment';
import axios from 'axios';

export default {
  components: {
    Layout,
    PageHeader,
    simplebar,
  },
  data() {
    return {
      chatData: [],
      chatMessagesData: [],
      todayMessagesCount: 0,
      title: "Chat Ataraxia",
      items: [
        {
          text: "Ataraxia",
          href: "javascript:void(0)",
        },
        {
          text: "Chat",
          active: true,
        },
      ],
      submitted: false,
      form: {
        message: "",
      },
      username: "Smash Burguer",
      bottonDisabled: false,
    };
  },
  computed: {
    // Group messages by date
    groupedMessages() {
      // First, sort messages by created_at
      const sortedMessages = this.chatMessagesData.sort((a, b) => new Date(a.created_at) - new Date(b.created_at));

      // Group messages by date
      const groups = [];
      let currentDate = null;

      sortedMessages.forEach((message) => {
        const messageDate = moment(message.created_at).format('YYYY-MM-DD');

        if (currentDate !== messageDate) {
          currentDate = messageDate;
          groups.push({
            date: currentDate,
            messages: [],
          });
        }

        groups[groups.length - 1].messages.push(message);
      });

      return groups;
    },
    // Contar los mensajes enviados hoy
    messagesToday() {
      const today = moment().format('YYYY-MM-DD'); // Fecha de hoy
      return this.chatMessagesData.filter(
        (msg) => moment(msg.created_at).format('YYYY-MM-DD') === today && msg.name == 'Ataraxia'
      ).length;
    },
  },
  methods: {
    fetchMessages() {
      axios.get('/api/messages')
        .then(res => {
          this.chatMessagesData = res.data.messages;
          // Ensure each message has 'created_at' field
          this.chatMessagesData.forEach(message => {
            if (!message.created_at) {
              message.created_at = message.time; // Adjust based on your data
            }
            if (!message.time) {
              message.time = moment(message.created_at).format('HH:mm');
            }
          });
          this.todayMessagesCount = res.data.todayMessagesCount;
          this.handleScroll();
        })
        .catch(error => {
          console.error('Error fetching messages:', error);
        });
    },
    formatDateHeader(dateString) {
      const date = moment(dateString);
      const today = moment();
      const yesterday = moment().subtract(1, 'days');

      if (date.isSame(today, 'day')) {
        return 'Hoy';
      } else if (date.isSame(yesterday, 'day')) {
        return 'Ayer';
      } else {
        return date.format('DD/MM/YYYY'); // Adjust the format as needed
      }
    },
    /**
     * Char form Submit
     */
    formSubmit(e) {
      this.submitted = true;

      // stop here if form is invalid

      const message = this.form.message;
      const currentDate = new Date();
      let messageData = {
        align: "right",
        name: this.username,
        message,
        time: currentDate.getHours() + ":" + currentDate.getMinutes(),
        created_at: new Date().toISOString(),
      };
      // Optimistically add the user's message
      this.chatMessagesData.push(messageData);
      this.handleScroll();

      axios.post('/api/messages', messageData )
        .then(response => {
          const { assistantMessage } = response.data;
          this.chatMessagesData.push({
            ...assistantMessage,
            created_at: new Date().toISOString(),
          });
          this.handleScroll();
        })
        .catch(error => {
          console.error('Error sending message:', error);
        })
        .finally(() => {
          this.submitted = false;
        });

      this.form.message = '';
    },
    handleScroll() {
      this.$nextTick(() => {
        const container = document.querySelector("#containerElement .simplebar-content-wrapper");
        if (container) {
          const scrollHeight = container.scrollHeight;
          container.scrollTo({ top: scrollHeight, behavior: "smooth" });
        }
      });
    },
    copyMessage(message) {
      // Crear un elemento de texto temporal para copiar al portapapeles
      const el = document.createElement('textarea');
      el.value = message;
      document.body.appendChild(el);
      el.select();
      document.execCommand('copy');
      document.body.removeChild(el);

      // Mostrar un mensaje de confirmación si lo deseas
      console.log("Mensaje copiado: ", message);
    },
  },
  mounted() {
    this.fetchMessages();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="d-lg-flex">
      <div class="w-100 user-chat">
        <div class="card">
          <div class="p-4 border-bottom">
            <div class="row">
              <div class="col-md-4 col-9">
                <h5 class="font-size-15 mb-1">{{ username }}</h5>
                <p class="text-muted mb-0">
                  <i class="mdi mdi-circle text-success align-middle me-1"></i>
                  Activo Ahora
                </p>
              </div>
              <div class="col-md-8 col-3">
                <ul class="list-inline user-chat-nav text-end mb-0">
                  <li class="list-inline-item d-none d-sm-inline-block">
                    <b-dropdown menu-class="dropdown-menu-md dropdown-menu-end" variant="white"
                      right toggle-class="nav-btn">
                      <template v-slot:button-content>
                        <i class="bx bx-search-alt-2"></i>
                      </template>
                      <form class="p-3">
                        <div class="form-group m-0">
                          <div class="input-group">
                            <input type="text" class="form-control" placeholder="Buscar ..."
                              aria-label="Recipient's username" />
                            <div class="input-group-append">
                              <button class="btn btn-primary" type="submit">
                                <i class="mdi mdi-magnify"></i>
                              </button>
                            </div>
                          </div>
                        </div>
                      </form>
                    </b-dropdown>
                  </li>
                </ul>
              </div>
            </div>
          </div>

          <div class="chat-users">
            <div class="chat-conversation p-3">
              <simplebar style="max-height: 470px;min-height: 470px;" id="containerElement" ref="current">
                <ul class="list-unstyled">
                  <li v-for="group in groupedMessages" :key="group.date">
                    <div class="chat-day-title">
                      <span class="title">{{ formatDateHeader(group.date) }}</span>
                    </div>
                    <ul class="list-unstyled">
                      <li v-for="data in group.messages" :key="data.id" :class="{ right: data.align === 'right' }">
                        <div class="conversation-list">
                          <b-dropdown variant="white" menu-class="dropdown-menu-end">
                            <template v-slot:button-content>
                              <i class="bx bx-dots-vertical-rounded"></i>
                            </template>
                            <b-dropdown-item @click="copyMessage(data.message)">Copiar</b-dropdown-item>
                          </b-dropdown>
                          <div class="ctext-wrap">
                            <div class="conversation-name">{{ data.name }}</div>
                            <p>{{ data.message }}</p>
                            <p class="chat-time mb-0">
                              <i class="bx bx-time-five align-middle me-1"></i>
                              {{ data.time }}
                            </p>
                          </div>
                        </div>
                      </li>
                    </ul>
                  </li>
                </ul>
              </simplebar>
            </div>
            <div class="p-3 chat-input-section">
                <p class="small" :class="{'text-danger': messagesToday >= (user?.message_limit ?? 7),'text-muted': messagesToday < (user?.message_limit ?? 7)}">
                Mensajes enviados hoy: {{ messagesToday }}/{{ user?.message_limit ?? '7' }}
                </p>
              <form @submit.prevent="formSubmit" class="row">
                <div class="col">
                  <div class="position-relative">
                    <input type="text" v-model="form.message"
                      class="form-control chat-input rounded"
                      placeholder="Ingresar Pregunta..." />
                  </div>
                </div>
                <div class="col-auto">
                  <button type="submit" class="btn btn-primary btn-rounded chat-send w-md"
                    :disabled="(user?.message_limit ?? 7) <= messagesToday || submitted || form.message==''">
                    <span class="d-none d-sm-inline-block me-2">Enviar</span>
                    <i class="mdi mdi-send"></i>
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<style scoped>
.text-danger {
  color: red;
}
</style>